module.exports = __webpack_public_path__ + "static/media/black_page.a076361c.jpg";